(() => {
  const init = (root) => {
    if (!root || root.dataset.ready) return;
    const articles = new Map([...root.querySelectorAll('[data-journal-article]')].map(el => [el.dataset.journalArticle, el]));
    const firstArticle = articles.get('1');
    const firstTitle = firstArticle?.querySelector('h2');
    const firstParagraph = firstArticle?.querySelector('p');
    if (!firstTitle || !firstParagraph) return;
    root.dataset.ready = 'true';
    const labels = JSON.parse(root.querySelector('[data-journal-labels]').textContent);
    const setText = (selector, text) => root.querySelectorAll(selector).forEach(el => {el.textContent = text;});
    const firstCard = root.querySelector('[data-journal-card="1"]');
    firstCard.querySelector('[data-journal-title]').textContent = firstTitle.textContent.trim();
    firstCard.querySelector('[data-journal-excerpt]').textContent = firstParagraph.textContent.trim();
    setText('[data-journal-series]', labels.series);
    setText('[data-journal-read]', labels.read);
    setText('[data-journal-back-label]', labels.back);
    const urlFor = (entry) => { const url = new URL(location.href); url.searchParams.delete('journal_entry'); if(entry) url.searchParams.set('journal_entry',entry); return url; };
    root.querySelectorAll('[data-journal-open]').forEach(a => {a.href = urlFor(a.dataset.journalOpen).href;});
    const back = root.querySelector('[data-journal-back]');
    back.href = urlFor(null).href;
    const render = (focus) => {
      const entry = new URL(location.href).searchParams.get('journal_entry');
      const reading = articles.has(entry);
      root.querySelector('.bec-journal-preview__listing').hidden = reading;
      root.querySelector('[data-journal-reader]').hidden = !reading;
      back.hidden = !reading;
      for (const [key, article] of articles) article.hidden = !reading || key !== entry;
      const readerImage = root.querySelector('[data-journal-reader-image]');
      readerImage.replaceChildren();
      if (reading) {
        const image = root.querySelector(`[data-journal-card="${entry}"] img`);
        if(image) readerImage.append(image.cloneNode(true));
      }
      root.querySelector('[data-journal-reader-note]').hidden = true;
      if(focus) {
        const target = reading ? articles.get(entry).querySelector('h2') : root.querySelector('[data-journal-title]');
        target.tabIndex = -1; target.focus({preventScroll:true});
        root.scrollIntoView({block:'start',behavior:'instant'});
      }
    };
    root.addEventListener('click',event => {
      const a = event.target.closest('[data-journal-open],[data-journal-back]');
      if(!a || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      history.pushState({},'',urlFor(a.dataset.journalOpen || null));
      render(true);
    });
    window.addEventListener('popstate',() => render(false));
    render(false);
  };
  document.querySelectorAll('[data-journal-preview]').forEach(init);
  document.addEventListener('shopify:section:load',event => init(event.target.querySelector('[data-journal-preview]')));
})();
